export default "<!--<router-outlet></router-outlet>-->\n<app-homepage></app-homepage>\n"